/* eslint-disable react/prop-types */
import { useAbility } from '@casl/react';
import React, { memo } from 'react';

import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';
import { AbilityContext } from '../../casl/AbilityContext';

export function EventLink({ id, displayName, eventGroupId }) {
  const ability = useAbility(AbilityContext);
  const canViewEvent = ability.can('read', 'Event');
  if (id && canViewEvent) {
    const path = eventGroupId
      ? `/event-group/${eventGroupId}/events/${id}/detail`
      : `/event/${id}`;
    return (
      <Link component={RouterLink} to={path}>
        {displayName}
      </Link>
    );
  }
  return displayName;
}

export default memo(EventLink);
